// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .event {
  width: 100%;
  max-width: 800px;
  margin-top: 10px auto;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  color: #000;
}
.theme-light .event .head {
  background-color: white;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.theme-light .event .head .headleft {
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
  color: #555;
}
.theme-light .event .head .headleft a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #000;
  text-decoration: none;
}
.theme-light .event .head .headleft img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-light .event .head .headright {
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
  color: #555;
}
.theme-light .event .head .headright a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #000;
  text-decoration: none;
}
.theme-light .event .head .headright img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-light .event .head .userInfo a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #000;
  text-decoration: none;
}
.theme-light .event .head .userInfo img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-light .event .head .targetInfo {
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
  color: #555;
}
.theme-light .event .head .targetInfo a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #000;
  text-decoration: none;
}
.theme-light .event .head .targetInfo img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-light .event .head .targetInfo .targetName {
  margin-right: 10px;
  padding: 5px;
  color: #000;
}
.theme-light .event .head .targetInfo .targetNumber {
  padding: 5px;
  margin-right: 10px;
}
.theme-light .event .head .targetInfo .status {
  padding: 5px;
  margin-right: 10px;
}
.theme-light .event .info {
  display: flex;
  padding: 12px 15px;
  text-align: left;
  color: #555;
  justify-content: space-between;
  padding: 5px 15px;
  border-collapse: collapse;
}
.theme-light .event .body {
  background-color: #f6f3f3;
}
.theme-light .event .body .mapDetails {
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
}
.theme-dark .event {
  width: 100%;
  max-width: 800px;
  margin-top: 10px auto;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  color: #fffef9;
}
.theme-dark .event .head {
  background-color: #222;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.theme-dark .event .head .headleft {
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
  color: #d1d0c9;
}
.theme-dark .event .head .headleft a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fffef9;
  text-decoration: none;
}
.theme-dark .event .head .headleft img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-dark .event .head .headright {
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
  color: #d1d0c9;
}
.theme-dark .event .head .headright a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fffef9;
  text-decoration: none;
}
.theme-dark .event .head .headright img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-dark .event .head .userInfo a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fffef9;
  text-decoration: none;
}
.theme-dark .event .head .userInfo img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-dark .event .head .targetInfo {
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
  color: #d1d0c9;
}
.theme-dark .event .head .targetInfo a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fffef9;
  text-decoration: none;
}
.theme-dark .event .head .targetInfo img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-dark .event .head .targetInfo .targetName {
  margin-right: 10px;
  padding: 5px;
  color: #fffef9;
}
.theme-dark .event .head .targetInfo .targetNumber {
  padding: 5px;
  margin-right: 10px;
}
.theme-dark .event .head .targetInfo .status {
  padding: 5px;
  margin-right: 10px;
}
.theme-dark .event .info {
  display: flex;
  padding: 12px 15px;
  text-align: left;
  color: #d1d0c9;
  justify-content: space-between;
  padding: 5px 15px;
  border-collapse: collapse;
}
.theme-dark .event .body {
  background-color: #333;
}
.theme-dark .event .body .mapDetails {
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/components/osint/osintEvent.scss"],"names":[],"mappings":"AAqBI;ECjBA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,8BAAA;EACA,WAAA;AAFJ;AAII;EACE,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAFN;AAIM;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AAFR;AAGQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;AADV;AAGQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AADV;AAIM;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AAFR;AAGQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;AADV;AAGQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AADV;AAKQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;AAHV;AAKQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAHV;AAMM;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AAJR;AAKQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;AAHV;AAKQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAHV;AAKQ;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAHV;AAKQ;EACE,YAAA;EACA,kBAAA;AAHV;AAKQ;EACE,YAAA;EACA,kBAAA;AAHV;AAOI;EACE,aAAA;EACA,kBAAA;EAEA,gBAAA;EACA,WAAA;EACA,8BAAA;EACA,iBAAA;EACA,yBAAA;AANN;AAQI;EACE,yBAAA;AANN;AAOM;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AALR;ADrGI;ECjBA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,8BAAA;EACA,cAAA;AAyHJ;AAvHI;EACE,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAyHN;AAvHM;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AAyHR;AAxHQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,qBAAA;AA0HV;AAxHQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA0HV;AAvHM;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AAyHR;AAxHQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,qBAAA;AA0HV;AAxHQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA0HV;AAtHQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,qBAAA;AAwHV;AAtHQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAwHV;AArHM;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AAuHR;AAtHQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,qBAAA;AAwHV;AAtHQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAwHV;AAtHQ;EACE,kBAAA;EACA,YAAA;EACA,cAAA;AAwHV;AAtHQ;EACE,YAAA;EACA,kBAAA;AAwHV;AAtHQ;EACE,YAAA;EACA,kBAAA;AAwHV;AApHI;EACE,aAAA;EACA,kBAAA;EAEA,gBAAA;EACA,cAAA;EACA,8BAAA;EACA,iBAAA;EACA,yBAAA;AAqHN;AAnHI;EACE,sBAAA;AAqHN;AApHM;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AAsHR","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.event{\n  @include themify($themes) {\n    width: 100%;\n    max-width: 800px;\n    margin-top: 10px auto;\n    border-collapse: collapse;\n    font-family: Arial, sans-serif;\n    color: themed(\"textColor\");\n  \n    .head {\n      background-color: themed(\"bg\");\n      font-weight: bold;\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n\n      .headleft {\n        display: flex;\n        justify-content: space-between;\n        padding: 12px 15px;\n        border: 1px solid #ddd;\n        text-align: left;\n        color: themed(\"textColorSoft\");\n        a {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n          color: themed(\"textColor\");\n          text-decoration: none;\n        }\n        img {\n          width: 30px;\n          height: 30px;\n          border-radius: 50%;\n          object-fit: cover;\n        }\n      }\n      .headright {\n        display: flex;\n        justify-content: space-between;\n        padding: 12px 15px;\n        border: 1px solid #ddd;\n        text-align: left;\n        color: themed(\"textColorSoft\");\n        a {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n          color: themed(\"textColor\");\n          text-decoration: none;\n        }\n        img {\n          width: 30px;\n          height: 30px;\n          border-radius: 50%;\n          object-fit: cover;\n        }\n      }\n      .userInfo {\n        a {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n          color: themed(\"textColor\");\n          text-decoration: none;\n        }\n        img {\n          width: 30px;\n          height: 30px;\n          border-radius: 50%;\n          object-fit: cover;\n        }\n      }\n      .targetInfo {\n        display: flex;\n        justify-content: space-between;\n        padding: 12px 15px;\n        border: 1px solid #ddd;\n        text-align: left;\n        color: themed(\"textColorSoft\");\n        a {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n          color: themed(\"textColor\");\n          text-decoration: none;\n        }\n        img {\n          width: 30px;\n          height: 30px;\n          border-radius: 50%;\n          object-fit: cover;\n        }\n        .targetName {\n          margin-right: 10px;\n          padding: 5px;\n          color: themed(\"textColor\");\n        }\n        .targetNumber {\n          padding: 5px;\n          margin-right: 10px;\n        }\n        .status {\n          padding: 5px;\n          margin-right: 10px;\n        }\n      }\n    }\n    .info {\n      display: flex;\n      padding: 12px 15px;\n      // border: 1px solid #454444;\n      text-align: left;\n      color: themed(\"textColorSoft\");\n      justify-content: space-between;\n      padding: 5px 15px;\n      border-collapse: collapse;\n    }\n    .body {\n      background-color: themed(\"bgSoft\");\n      .mapDetails {\n        display: flex;\n        justify-content: space-between;\n        padding: 12px 15px;\n        border: 1px solid #ddd;\n        text-align: left;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
